// orders modules
import axios from 'axios';
import moment from 'moment';
import {
  ORDER_URL,
  PENDING_ORDERS_URL,
  CONSOLIDATED_ORDERS_URL,
  SALES_ORDER_URL,
  SALES_INVOICE_URL,
  INBOUND_URL,
  DSQ_FILE_URL,
  INBOUND_INVENTORY_URL,
  PRODUCT_LIST_URL,
  PRODUCT_DETAIL_URL,
  OVERSEAS_ORDER_URL,
  INBOUND_PRODUCT_URL,
  UPLOAD_ORDER_FILE_URL,
} from '../../api/url'

// initial state
const state = {
  orderDetails: [],
  
  orderList: [],
  orderListPaginate: '',
  orderListCount: '',
  
  orderDetail: {},
  activeOrder: '',
  
  inboundInventory: [],
  inboundInventoryPaginate: '',
  inboundInventoryCount: '',
  
  productList: [],
  productListPaginate: '',
  productListCount: '',
  
  inboundProducts: [],
}

// actions
const actions = {
  //dsq
  submitFile: (context, fileData) => axios({
    url: DSQ_FILE_URL,
    method: 'POST',
    data: fileData,
    headers: {
      Authorization: `JWT ${localStorage.getItem("token")}`
    }
  }),
  submit: (context, orderData) => axios({
    url: OVERSEAS_ORDER_URL,
    method: 'post',
    data: orderData,
    headers: {
      Authorization: `JWT ${localStorage.getItem("token")}`
    }
  }),
  //fetch product list by limit and page
  fetchProductList(context, [limit, pages]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${PRODUCT_LIST_URL}?limit=${limit}&page=${pages}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    axios(config)
    .then(response => {
      context.commit('fetchProductList', response.data);
    })
    .catch (err => {
      console.log('fetchProductList', err);
    })
  },
  fetchProductDetails(context,productId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${PRODUCT_DETAIL_URL}${productId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config);
  },
  fetchInboundProducts(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${INBOUND_PRODUCT_URL}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    axios(config)
    .then(response => {
      context.commit('fetchInboundProducts', response.data);
    })
    .catch (err => {
      console.log('fetchInboundProducts', err);
    })
  },
  //fetch inbound inventory by limit and paage
  fetchInboundInventory(context, [limit, pages]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${INBOUND_INVENTORY_URL}?limit=${limit}&page=${pages}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    axios(config)
    .then(response => {
      context.commit('fetchInboundInventory', response.data);
    })
    .catch (err => {
      console.log('fetchInboundInventory', err);
    })
  },
  submitOutboundLabel: (context, [fileData, id]) => axios({
    url:`${UPLOAD_ORDER_FILE_URL}${id}/`,
    method: 'POST',
    data: fileData,
    headers: {
      Authorization: `JWT ${localStorage.getItem("token")}`
    }
  }),
  //fetch order by timeframe
  fetchOrderByTimeFrame(context, [start_date, end_date, type, limit, pages, bol, exp]) {
    let start = '';
    let end = '';
    let ex = '';
    
    if (exp===true) {
      ex = `&export=${exp}`;
    }
    
    if (start_date && end_date) {
      start = `&start_date=${start_date}`;
      end = `&end_date=${end_date}`;
    }
    
    const token = localStorage.getItem('token');
    // url: `${DSQ_ORDER_URL}${timeFrame}`,
    const config = {
      method: 'get',
      url: `${OVERSEAS_ORDER_URL}?limit=${limit}&page=${pages}${type}${start}${end}${ex}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    axios(config)
    .then(response => {
      context.commit('fetchOrderByTimeFrame', [response.data, bol]);
    })
    .catch (err => {
      console.log('fetchOrderByTimeFrame', err);
    })
  },
  //fetch order detail
  fetchOrderDetails(context, orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${ORDER_URL}`,
      params: {
        pk: orderId,
      },  
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
   //.then(response => {
         let OrderTime = response.data.map(Sales_Order_Line=>{
           const obj = {
             ...Sales_Order_Line,
             OrderDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
           }
           return obj;
       });
   //   context.commit('fetchOrderDetails', OrderTime);
   // }), (err => {
   //    console.log('fetchorderdetails', err);
   // })
  },
  //fetch Consolidated Orders
  fetchConsolidatedOrders(context) {
     const token = localStorage.getItem('token');
     const config = {
       method: 'get',
       url: CONSOLIDATED_ORDERS_URL,
       headers: {
         Authorization: `JWT ${token}`,
       },
     };
     axios(config)
     .then(response => {
       context.commit('fetchConsolidatedOrders', response.data);
     }), (err => {
       console.log ('fetchConsolidatedOrders', err);
     })
  },
  fetchSODetails(context, orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${OVERSEAS_ORDER_URL}${orderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    axios(config)
    .then(response => {
      context.commit('fetchSODetails', response.data);
    }), (err => {
      console.log ('fetchConsolidatedOrders', err);
    })
  },
  fetchSIDetails(context,orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${SALES_INVOICE_URL}`,
      params: {
        pk: orderId,
      },  
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config);
  },
  //cancel order
  cancelOrder(context,orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'put',
      url: `${ORDER_URL}/cancel/${orderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    axios(config)
    .then(response => {
      context.commit('cancelOrder', response.data);
    }), (err => {
      console.log ('cancelordererror', err);
    })
  },
}
// mutations
const mutations = {
  fetchOrderDetails(state, payload) {
    state.orderDetails = payload
  },
  fetchOrderByTimeFrame(state, [payload, bol]) {
    let orders = payload.record;
    if(bol===true) {
      orders = orders.filter(order => order.ProNum !== null);
    } else if (bol===false) {
      orders = orders.filter(order => order.ProNum === null);
    }
    
    let orderWithModifiedDate = orders.map(Order => {
      const obj = {
        ...Order,
        OrderDate: moment(Order.OrderDate).format("MM/DD/YY"),
        DispatchDate: moment(Order.DispatchDate).format("MM/DD/YY"),
        FinalPrice: Order.FinalPrice.toFixed(2),
      }
      return obj;
    })
    state.orderList = orderWithModifiedDate
    state.orderListPaginate = payload.pages;
    state.orderListCount = payload.count;
  },
  fetchSODetails(state, payload) {
    state.orderDetail = payload;
  },
  updateActiveOrder(state, payload) {
    state.activeOrder = payload;
  },
  fetchInboundInventory(state, payload) {
    state.inboundInventory = payload.record;
    state.inboundInventoryPaginate = payload.pages;
    state.inboundInventoryCount = payload.count;
  },
  fetchProductList(state, payload) {
    state.productList = payload.record;
    state.productListPaginate = payload.pages;
    state.productListCount = payload.count;
  },
  fetchInboundProducts(state, payload) {
    state.inboundProducts = payload.record;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js